import Vue from 'vue'
import VueRouter from 'vue-router'
import { formatPageTitle } from '@/utils/index'

import Layout from '../layout/index.vue'
Vue.use(VueRouter)


export const route404 = {
    path: '**',
    name: 'not-found',
    component: () => import(/* webpackChunkName: "404" */ '../views/404.vue'),
    meta: {
        meta: { name: '404', pageTitle: formatPageTitle('404')}
    }
}

const routes = [
    {
        path: '/login',
        component: () => import(/* webpackChunkName: "login" */ '../views/login/Index.vue'),
        meta: { name: 'Log In', pageTitle: formatPageTitle('Log In')}
    },
    {
        path: '/force_reset_password',
        component: () => import(/* webpackChunkName: "login" */ '../views/login/ForceResetPassword.vue'),
        meta: { name: 'Force Reset Password', pageTitle: formatPageTitle('Force Reset Password')}
    },
    {
        path: '/geotab',
        component: () => import(/* webpackChunkName: "login" */ '../views/login/Geotab.vue'),
        meta: { name: 'GeoTab Login', pageTitle: formatPageTitle('GeoTab Login')}
    },
    {
        path: '/',
        component: Layout,
        redirect: '/dashboard',
        name: 'home',
    },

    //Profile
    {
        path: '/profile',
        component: Layout,
        children: [
            {
                path: '',
                component: () => import(/* webpackChunkName: "profile" */ '../views/profile/Index.vue'),
                name: 'Profile',
                meta: { name: 'Profile', pageTitle: formatPageTitle('Your Profile')},
            }
        ]
    },
]


const createRouter = () => new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior: () => ({ y: 0 }),
    routes
})

const router = createRouter()

export function resetRouter() {
    const newRouter = createRouter()
    router.matcher = newRouter.matcher // reset router
}

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
    return originalReplace.call(this, location).catch(err => err)
}

export default router
